module.exports = __webpack_public_path__ + "img/monovolume.c0046910.webp";